import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { MorningMinutesComponent } from './morning-minutes-component';
import { DailyLogPageModule } from '../../daily-log/daily-log/daily-log.module';
import { SharedModule } from '../../shared/shared.module';
import { TextMaskModule } from 'angular2-text-mask';
import { DirectivesModule } from '../../../directives/directives.module';

@NgModule({
  declarations: [
    MorningMinutesComponent,
  ],
  imports: [
    DirectivesModule,
    IonicPageModule.forChild(MorningMinutesComponent),
    DailyLogPageModule,
    SharedModule,
    TextMaskModule,
  ],
  exports: [
    MorningMinutesComponent
  ]
})
export class MorningMinutesComponentModule {
}



// WEBPACK FOOTER //
// ./src/pages/morning-minutes/morning-minutes-component/morning-minutes-component.module.ts